<template>
    <div class="row" v-if="userType != 'B2B'">
          <subscribeModal v-if="showModalInfo" @close="showModalInfo = false"
            :sitekey = "sitekey"
            :firstname = "firstname"
            :email = "email"
            @on-success="onSuccess()"
          >
        </subscribeModal>
        <div class="col-sm-12 col-md-4">
            <p class="h4" v-html="label_h4"></p>
        </div>
        <div class="col-sm-12 col-md-3">
            <input type="text" v-model.trim.lazy="firstname" placeholder="First Name" style="margin-bottom: 10px; width: 100%; height: 40px; line-height: 2;padding: 10px;"/>
        </div>
        <div class="col-sm-12 col-md-3">
            <input type="email" v-model.trim.lazy="email" placeholder="Email" style="margin-bottom: 10px; width: 100%; height: 40px; line-height: 2;padding: 10px;"/>
        </div>
        <div class="col-sm-12 col-md-2" style="text-align: center;">
            <span class="btn-white-outline-blue" style="cursor: pointer;" @click="onClickHandler()">SUBSCRIBE</span>
        </div>
        <div class="col-sm-12 col-md-4" v-if="showSuccess"> &nbsp;</div>
        <div class="col-sm-12 col-md-8" v-if="showSuccess">
            <p style="font-weight: 600; font-size: larger; margin-top: -20px;">Thank you for signing up to our newsletter!</p>
        </div>
    </div>
</template>

<script>
import subscribeModal from './subscribe-modal.vue';

export default {
    name: "footer-subscribe",
    components: {
        subscribeModal
    },
    props: {
        sitekey: {
          type: String,
          required: true
        },
        label_h4: {
          type: String,
          default: "Subscribe to get ready <br>for your next adventure!"
        },
        label_subscribe: {
          type: String,
          default : "SUBSCRIBE"
        },
        label_submit: {
          type: String,
          default : "SUBMIT"
        },
    },
    data() {
        return {
            firstname : '',
            email : '',
            showModalInfo : 0,
            showSuccess : 0,
        };
    },
    methods: {
        validEmail: function (email) {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        },
        onSuccess() {
            this.firstname = '';
            this.email = '';
            this.showSuccess = 1;
        },
        onClickHandler(){
            if(this.firstname && this.email)
                if(this.validEmail(this.email))
                    this.showModalInfo = 1;
                else
                    alert('Please input valid email.');
            else
            alert('Please fill out the following form completely.');
        }

    },
    computed: {
        userType() {
          return this.$store.getters["auth/userType"];
        },
    }
};
</script>
